import React, { useReducer, useState } from 'react';
import { Editor } from './Editor';
import { Console } from './Console';
import { Popup } from './Popup';
import { LoopMePlayer } from './LoopMePlayer';
import { GooglePlayer } from './GooglePlayer';
import { Layout, VerticalGroup, Main, Button, Text, Icon } from '@libs/uikit/Components';
import { Header } from './Header';
import { General } from './General';
import { errors } from './error';
import { HG } from './HG';
import { Footer } from './Footer';

export const App = () => {
    const [count, setCount] = useState(0);
    const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
        data: { type: 'empty', value: '' },
        googleEvents: [],
        loopmeEvents: [],
    });
    const { data, googleEvents, loopmeEvents } = state;
    const [, link = ''] = window.location.href.split('response=');
    const [status, setStatus] = useState("Not ready");
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const [popup, setPopup] = useState(null);
    const onPopupClose = () => setPopup(null);

    const clearEvents = () => {
        setState({
            googleEvents: [],
            loopmeEvents: [],
        });
    };

    const onSubmit = (data) => {
        setStartTime(Date.now());
        setCount(count + 1);
        setState({ data, googleEvents: [], loopmeEvents: [] });
    };

    const onGoogleEvent = (event) =>
        event &&
        setState({
            googleEvents: [
                ...state.googleEvents,
                {
                    type: event.type,
                    timestamp: new Date().toLocaleTimeString(),
                },
            ],
        });

    const onLoopmeEvent = (event) => {
        if (event?.type.includes('pending')) {
            setStatus('PENDING');
        }
        if (event?.type.includes('fulfilled')) {
            setStatus('FULFILLED');
        }
        if (event?.payload?.event?.includes('AdStarted')) {
            setEndTime(Date.now());
        }
        if (event?.payload?.event === 'AdDurationChange' && event?.payload?.adDuration) {
            setDuration(Math.floor(event.payload.adDuration));
        }
        event &&
        setState({
            loopmeEvents: [...state.loopmeEvents, { ...event, timestamp: new Date().toLocaleTimeString() }],
        });
    };

    const loopMeErrors = loopmeEvents.filter(
        (event) => event.type === 'playerData/onEventVpaid' && event?.payload?.event === 'AdError',
    );

    const hasErrors = loopMeErrors.length > 0;

    const reportError = () => {
        const _trackError = (link) => (er) => {
            return (new Image().src = `https://looptrk.com/sj/tr?id=vpaid_tester&et=CUSTOM&error=${
                er.errorCode
            }&message=${er.message}&time=${er.timestamp}&link=${encodeURIComponent(link)}`);
        };
        loopMeErrors.forEach(_trackError(data.value));
        setPopup({ type: 'report' });
    };

    const copyLink = ({ link }) => {
        setPopup({ type: 'link', link });
    };

    const copyXml = () => {
        setPopup({ type: 'vastCopy', link });
    };

    const general = loopmeEvents.filter(({ type }) => type === 'playerData/onEventGeneral');
    let timeToPlay = 0;
    if ((endTime - startTime) > 0) {
        timeToPlay = ((endTime - startTime) / 1000).toFixed(2);
    }

    return (
        <Layout>
            <Header />
            <VerticalGroup style={{ padding: '0 32px', marginTop: '64px' }}>
                <HG>
                    <Main>
                        <Editor defaultValue={decodeURIComponent(link)} onSubmit={onSubmit} onCopy={copyLink} />
                    </Main>
                </HG>

                <HG>
                    <Main>
                        <LoopMePlayer data={data} onEvent={onLoopmeEvent} />
                    </Main>
                    <Main>
                        <GooglePlayer data={data} onEvent={onGoogleEvent} count={count} />
                    </Main>
                </HG>

                <HG>
                    <Main>
                        <Console events={loopmeEvents} system="LoopMe" hasProblem={hasErrors} />
                    </Main>
                    <Main>
                        <Console events={googleEvents} system="Google" hasProblem={hasErrors} />
                    </Main>
                </HG>

                {hasErrors && (
                    <HG>
                        <Main>
                            <HG>
                                <Icon name="wiz_warning" style={{ color: 'red' }} />
                                <Text caption style={{ flex: 1 }}>
                                    [{loopMeErrors[0].payload.ERRORCODE}] -{' '}
                                    {errors[loopMeErrors[0].payload.ERRORCODE] || 'Unexpected error'}
                                </Text>
                                <Button secondary size="XL" className="report-btn" onClick={reportError}>
                                    report error
                                </Button>
                            </HG>
                        </Main>
                    </HG>
                )}

                {general.length ? (
                    <HG>
                        <Main>
                            {general.length ? (
                                <General
                                    general={general}
                                    status={status}
                                    onCopyXml={copyXml}
                                    timeToPlay={timeToPlay}
                                    duration={duration}
                                />
                            ) : null}
                            {/* <Button className="clear-btn default" onClick={clearEvents}>
                            clear events
                        </Button> */}
                        </Main>
                    </HG>
                ) : null}
                <Footer />
            </VerticalGroup>
            {popup?.type === 'report' && (
                <Popup title="Report" onClose={onPopupClose}>
                    <span>The error was reported!</span>
                </Popup>
            )}
            {popup?.type === 'link' && (
                <Popup title="Sharebale Link" onClose={onPopupClose}>
                    <span>The link was copied to your buffer!</span>
                </Popup>
            )}
            {popup?.type === 'vastCopy' && (
                <Popup title="VAST xml" onClose={onPopupClose}>
                    <span>VAST xml was copied to your buffer!</span>
                </Popup>
            )}
        </Layout>
    );
};
